import React, { useContext } from 'react';
import classnames from 'classnames';
import _ from 'underscore';
import PropTypes from 'prop-types';

import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { I18nContext } from '@bingads-webui-react/i18n-context';

import { getValidationMessageStyles } from './styles/validation-message';

export const ValidationMessage = ({
  index,
  selectedImage,
  isImageValid,
  getMinSizeByIndex,
  styleOverrides,
}) => {
  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getValidationMessageStyles({ styleOverrides: styleOverrides.validationMessage }));

  if (_.result(selectedImage, 'isIncluded') !== true) {
    // todo need to handle not supported state??
    if (!isImageValid) {
      const { minWidth, minHeight } = getMinSizeByIndex(index);

      const messageTemplate = _TL_('To include this aspect ratio, add a new image that is at least {{width}} x {{height}} pixels.');

      return (
        <span className={classnames('action-label', classes.validationError)}>
          {
            i18n.getString(messageTemplate, {
              width: minWidth,
              height: minHeight,
            })
          }
        </span>
      );
    }
  }

  return null;
};

ValidationMessage.propTypes = {
  index: PropTypes.number.isRequired,
  selectedImage: PropTypes.shape({}).isRequired,
  getMinSizeByIndex: PropTypes.func.isRequired,
  isImageValid: PropTypes.bool.isRequired,
  styleOverrides: PropTypes.shape({
    validationMessage: PropTypes.shape({}),
  }),
};

ValidationMessage.defaultProps = {
  styleOverrides: {},
};
